import type { IconNode } from '../types';

/**
 * @name wheel
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIyLjUiIC8+CiAgPHBhdGggZD0iTTEyIDJ2Ny41IiAvPgogIDxwYXRoIGQ9Im0xOSA1LTUuMjMgNS4yMyIgLz4KICA8cGF0aCBkPSJNMjIgMTJoLTcuNSIgLz4KICA8cGF0aCBkPSJtMTkgMTktNS4yMy01LjIzIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNC41VjIyIiAvPgogIDxwYXRoIGQ9Ik0xMC4yMyAxMy43NyA1IDE5IiAvPgogIDxwYXRoIGQ9Ik05LjUgMTJIMiIgLz4KICA8cGF0aCBkPSJNMTAuMjMgMTAuMjMgNSA1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/wheel
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const wheel: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '2.5', key: 'ix0uyj' }],
  ['path', { d: 'M12 2v7.5', key: '1e5rl5' }],
  ['path', { d: 'm19 5-5.23 5.23', key: '1ezxxf' }],
  ['path', { d: 'M22 12h-7.5', key: 'le1719' }],
  ['path', { d: 'm19 19-5.23-5.23', key: 'p3fmgn' }],
  ['path', { d: 'M12 14.5V22', key: 'dgcmos' }],
  ['path', { d: 'M10.23 13.77 5 19', key: 'qwopd4' }],
  ['path', { d: 'M9.5 12H2', key: 'r7bup8' }],
  ['path', { d: 'M10.23 10.23 5 5', key: 'k2y7lj' }],
];

export default wheel;
